/* eslint-disable no-console */
// import { Box } from "@mui/system";
import { useHistory, useParams } from "react-router-dom";

import { timesheetApi } from "@api";
// import mobile_arrow_left from "@assets/Icons/arrow/mobile_arrow_left.svg";
import hot_yellow_frame from "@assets/Icons/hot_yellow_frame.svg";
import checkIcon from "@assets/checkIcon.png";
import xIcon from "@assets/xIcon.png";
import { appRouteEnums } from "@enums";
import { selectAuth, useAppSelector } from "@redux";
import { converUrlToGetId, formatDate, useAppNavigation, useFormWithSchema, useShowErrorFromApi } from "@utils";
import queryString from "query-string";
import { useEffect, useState } from "react";

import { AxiosError } from "axios";
import { AppAlert, AppModal, CircularLoader, CustomFormProvider, OTApprovalProcess, TimeSheetUserInfo } from "../../..";
import { useTimeSheetContext } from "../../context";
import { StyledNewTimeSheetForm } from "../../styles";
import { TimeSheetNightShiftFormSchemaType, timeSheetNightShiftFormSchema } from "../../validation";
import { FormSheetNightShift } from "../../widget";
import { decodeDraft } from "src/Utils/encodeUtils";
import { useRefreshTimesheet } from "../../hooks/useRefreshTimesheet";
import { OT_STATUS_OK, OT_STATUS_PENDING, OT_STATUS_REJECT } from "@configs";

/**
 * タイムシートのタイプが「日勤」および「夜勤」の場合のフォーム
 */
export function TimeSheetNightShift() {
  const [nameGroup, setNameGroup] = useState<string>("");
  const [idTimeSheetItem, setIdTimeSheetItem] = useState<number | null>(null);
  const [dateUpdate, setDateUpdate] = useState("");
  const [editLoading, setEditLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [status, setStatus] = useState<any>("");
  const [tsData, setTsData] = useState<any>({});

  const history = useHistory();
  const auth = useAppSelector(selectAuth);
  const { userInfo } = auth;
  const { navigatePreservingQuery } = useAppNavigation();
  const defaultDatePicker = queryString.parse(window.location.search)?.date;
  const parsed = queryString.parse(location.search);
  const params: any = useParams();
  const { employees, loading } = useTimeSheetContext();
  const showErrorFromApi = useShowErrorFromApi();
  const { refreshTimesheetData } = useRefreshTimesheet();

  const fetchListGroupsByUser = async (id: number) => {
    try {
      const result = await timesheetApi.listGroupsByUser(id);
      setNameGroup(result?.data?.data[0].name);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (!userInfo?.id) return;
    fetchListGroupsByUser(userInfo?.id);
  }, []);

  // console.log("employees form", employees);

  // const form = useFormWithSchema({
  //     schema: timeSheetNightShiftFormSchema,
  //     options: {
  //         defaultValues: {
  //             alcohol_check: false,
  //             check_date: defaultDatePicker
  //                 ? (defaultDatePicker as string)
  //                 : formatDate({ date: new Date(), format: "YYYY-MM-DD" }),
  //             device_check: "TANITAアルコールチェッカーEA-100",
  //         },
  //     },
  // });

  const idSelectType = converUrlToGetId(window.location.href);

  const formCreate = useFormWithSchema({
    schema: timeSheetNightShiftFormSchema.partial(),
    options: {
      defaultValues: {
        alcohol_check: true,
        check_date: defaultDatePicker ? (defaultDatePicker as string) : formatDate({ date: new Date(), format: "YYYY-MM-DD" }),
        device_check: "TANITAアルコールチェッカーEA-100",
      },
    },
  });
  const formUpdate = useFormWithSchema({
    schema: timeSheetNightShiftFormSchema.partial(),
  });

  const {
    reset: resetCreate,
    formState: { isSubmitting },
  } = formCreate;
  const {
    reset,
    formState: { isSubmitting: isSubmittingFormUpdate },
  } = formUpdate;

  // const form: any = params?.id ? formUpdate : formCreate;
  const form: any = parsed?.copy || params?.id ? formUpdate : formCreate;

  const buildDefaultFormData = (res, employees) => {
    const item = res?.data?.data?.timesheetItems?.[0];
    if (!item) return {};

    const {
      alcohol_default_check,
      inspector_default_check,
      driver_default_check,
      vehicle_default_check,
      device_default_check,
      start_time_check_alcohol,
      end_time_check_alcohol,
      start_capacity_alcohol,
      end_capacity_alcohol,
      driver_id,
      inspector_id,
      vehicle_id,
      device_check,
    } = item;

    return {
      device_check: device_default_check === 0 ? "TANITAアルコールチェッカーEA-100" : device_check,
      driver_id: driver_default_check === 0 ? "" : driver_id ? employees.find((e) => Number(e.value) === driver_id)?.value : "",
      inspector_id: inspector_default_check === 0 ? "" : inspector_id ? employees.find((e) => Number(e.value) === inspector_id)?.value : "",
      vehicle_id: vehicle_default_check === 0 ? "" : vehicle_id ?? "",
      list_constructions: [],

      start_time_check_alcohol: alcohol_default_check === 0 ? undefined : start_time_check_alcohol,
      end_time_check_alcohol: alcohol_default_check === 0 ? undefined : end_time_check_alcohol,
      start_capacity_alcohol: alcohol_default_check === 0 ? "" : start_capacity_alcohol,
      end_capacity_alcohol: alcohol_default_check === 0 ? "" : end_capacity_alcohol,
      alcohol_default_check: alcohol_default_check !== 0,
      inspector_default_check: inspector_default_check !== 0,
      driver_default_check: driver_default_check !== 0,
      vehicle_default_check: vehicle_default_check !== 0,
      device_default_check: device_default_check !== 0,
    };
  };

  //申請から来た値があるかどうか
  const isFromApplication = !!parsed?.draft;

  useEffect(() => {
    const initializeForm = async () => {
      const res = await timesheetApi.getLatestInfo();
      const defaultData = buildDefaultFormData(res, employees);

      //申請から値取得している場合の処理
      if (isFromApplication) {
        const rawDraft = parsed.draft;

        const draftEncoded = Array.isArray(rawDraft) ? rawDraft[0] : rawDraft;
        if (typeof draftEncoded === "string") {
          try {
            const draftDecoded = decodeDraft(draftEncoded);

            // アルコールチェック時間帯は申請内容を優先（前回値は日勤などとミスマッチする可能性があるため）
            const merged = {
              ...defaultData,
              ...draftDecoded,
            };

            resetCreate(merged);

          } catch (e) {
            console.error("Draft decode error", e);
          }
        };

      } else {
        //申請から来ていない場合の処理
        resetCreate(defaultData);
      };
    };

    if (employees.length > 0) {
      initializeForm();
    }

  }, [employees]);


  //申請から日報作成した時に処理が別になってしまうためコメントアウト
  // useEffect(() => {
  //   if (employees.length === 0) return;
  //   const getLastestInfo = async () => {
  //     try {
  //       setEditLoading(true);
  //       const res = await timesheetApi.getLatestInfo();
  //       const {
  //         alcohol_default_check,
  //         inspector_default_check,
  //         driver_default_check,
  //         vehicle_default_check,
  //         device_default_check,
  //         start_time_check_alcohol,
  //         end_time_check_alcohol,
  //         start_capacity_alcohol,
  //         end_capacity_alcohol,
  //         driver_id,
  //         inspector_id,
  //         vehicle_id,
  //         device_check,
  //       } = res.data.data.timesheetItems[0];
  //       resetCreate({
  //         device_check: device_default_check === 0 ? "TANITAアルコールチェッカーEA-100" : device_check,
  //         driver_id: driver_default_check === 0 ? "" : driver_id ? employees.find((employee) => employee.value === driver_id)?.value : "",
  //         inspector_id: inspector_default_check === 0 ? "" : inspector_id ? employees.find((employee) => employee.value === inspector_id)?.value : "",
  //         vehicle_id: vehicle_default_check === 0 ? "" : vehicle_id ? vehicle_id : "",
  //         list_constructions: [],

  //         start_time_check_alcohol: alcohol_default_check === 0 ? undefined : start_time_check_alcohol,
  //         end_time_check_alcohol: alcohol_default_check === 0 ? undefined : end_time_check_alcohol,
  //         start_capacity_alcohol: alcohol_default_check === 0 ? "" : start_capacity_alcohol,
  //         end_capacity_alcohol: alcohol_default_check === 0 ? "" : end_capacity_alcohol,
  //         alcohol_default_check: alcohol_default_check === 0 ? false : true,
  //         inspector_default_check: inspector_default_check === 0 ? false : true,
  //         driver_default_check: driver_default_check === 0 ? false : true,
  //         vehicle_default_check: vehicle_default_check === 0 ? false : true,
  //         device_default_check: device_default_check === 0 ? false : true,
  //       });
  //     } catch (error) {
  //       console.log(error);
  //     } finally {
  //       setEditLoading(false);
  //     }
  //   };
  //   getLastestInfo();
  // }, [employees, resetCreate]);

  // useEffect(() => {
  //   console.log("✅ フォーム初期値:", form.getValues());
  // }, [form]);

  const handleCreateTimeSheetNightShift = async (values: TimeSheetNightShiftFormSchemaType) => {
    const body = {
      // date: defaultDatePicker as string,
      date: values?.check_date,
      type: idSelectType,
      data: [
        {
          item_type: idSelectType === "3" ? "0" : idSelectType,
          ...values,
          alcohol_check: values.alcohol_check ? "1" : "0",
          alcohol_default_check: values.alcohol_default_check ? "1" : "0",
          inspector_default_check: values.inspector_default_check ? "1" : "0",
          driver_default_check: values.driver_default_check ? "1" : "0",
          vehicle_default_check: values.vehicle_default_check ? "1" : "0",
          device_default_check: values.device_default_check ? "1" : "0",
        },
      ],
    };

    try {
      await timesheetApi.addMultipleConstructionSite(body);
      await refreshTimesheetData(values.check_date.substring(0, 7));
      setIsSuccess(true);
      setSuccessMessage("正常に作成しました");
    } catch (error) {
      const err = error as AxiosError<any>;
      showErrorFromApi(err);
    }
  };
  const handleUpdateTimeSheetNightShift = async (values: TimeSheetNightShiftFormSchemaType) => {
    const body = parsed?.copy
      ? {
        type: idSelectType,
        // id: params?.id,
        //   date: defaultDatePicker as string,
        date: values?.check_date,
        data: [
          {
            item_type: idSelectType === "3" ? "0" : idSelectType,
            // id: idTimeSheetItem,
            ...values,
            alcohol_check: values.alcohol_check ? "1" : "0",
            alcohol_default_check: values.alcohol_default_check ? "1" : "0",
            inspector_default_check: values.inspector_default_check ? "1" : "0",
            driver_default_check: values.driver_default_check ? "1" : "0",
            vehicle_default_check: values.vehicle_default_check ? "1" : "0",
            device_default_check: values.device_default_check ? "1" : "0",
          },
        ],
      }
      : {
        type: idSelectType,
        id: params?.id,
        date: dateUpdate,
        data: [
          {
            item_type: idSelectType === "3" ? "0" : idSelectType,
            id: idTimeSheetItem,
            ...values,
            alcohol_check: values.alcohol_check ? "1" : "0",
            alcohol_default_check: values.alcohol_default_check ? "1" : "0",
            inspector_default_check: values.inspector_default_check ? "1" : "0",
            driver_default_check: values.driver_default_check ? "1" : "0",
            vehicle_default_check: values.vehicle_default_check ? "1" : "0",
            device_default_check: values.device_default_check ? "1" : "0",
          },
        ],
      };

    try {
      if (parsed?.copy) {
        await timesheetApi.addMultipleConstructionSite(body);
      } else {
        await timesheetApi.updateTimesheetDetail(body, params?.id);
      }
      await refreshTimesheetData(values.check_date.substring(0, 7));
      setIsSuccess(true);
      setSuccessMessage("正常に更新しました");
    } catch (error: any) {
      const err = error as AxiosError<any>;
      showErrorFromApi(err);
    }
  };

  // const onSubmit = params?.id ? handleUpdateTimeSheetNightShift : handleCreateTimeSheetNightShift;
  const onSubmit = parsed?.copy || params?.id ? handleUpdateTimeSheetNightShift : handleCreateTimeSheetNightShift;

  useEffect(() => {
    // if (!params.id || employees.length === 0) return;
    if (employees.length === 0) return;

    const nightShiftDetails = async () => {
      setEditLoading(true);
      try {
        // const res = await timesheetApi.viewTimesheetDetail(params.id);
        const res = (parsed?.copy || params?.id) && (await timesheetApi.viewTimesheetDetail(parsed?.copy ? parsed?.copy : params.id));

        //コピーされた日報かどうかチェック
        const isCopy = !!parsed.copy;

        //コピーされた日報の場合、承認ステータス情報は不要
        if (!isCopy) {
          //承認ステータス表示用
          if (res.data.confirmation[0]) {
            //画面上部ステータス
            setStatus(res.data.status);

            //OTApprovalProcessコンポーネント用
            setTsData(res.data);
          }
        }

        const {
          alcohol_check,
          check_date,
          device_check,
          driver,
          inspector,
          vehicle,
          TimesheetItemConstruction,
          id,
          date,
          start_time_check_alcohol,
          end_time_check_alcohol,
          start_capacity_alcohol,
          end_capacity_alcohol,
          alcohol_default_check,
          inspector_default_check,
          driver_default_check,
          vehicle_default_check,
          device_default_check,
        } = res.data.items[0];
        console.log("res.data.items[0]", res.data.items[0]);
        const nightShiftValuesForm: TimeSheetNightShiftFormSchemaType = {
          alcohol_check: alcohol_check === 0 ? false : true,
          check_date: parsed.date ? parsed.date : check_date,
          // check_date,
          device_check,
          driver_id: driver ? employees.find((employee) => Number(employee.value) === driver?.id)?.value : "",
          inspector_id: inspector ? employees.find((employee) => Number(employee.value) === inspector?.id)?.value : "",
          vehicle_id: vehicle?.id ? vehicle?.id : "",
          list_constructions: TimesheetItemConstruction.map((construction) => ({
            break_time: construction.break_time,
            memo: construction.memo || "",
            construction_id: construction.construction_id,
            start_at: construction.start_at,
            listConstruction: construction.construction,
            stop_at: construction.stop_at,
            weather_id: construction.weather_id.toString(),
            contractors: construction.contractor_timesheet_item.map((contractorItem) => ({
              contractor_id: contractorItem.contractor_id,
              number_of_people: Number(contractorItem.number_of_people),
              work_type_1: contractorItem.work_types.filter((workType) => workType.type === 1).map((workType) => String(workType.id)),
              work_type_2: contractorItem.work_types.filter((workType) => workType.type === 2).map((workType) => String(workType.id)),
              work_type_3: contractorItem.work_types.filter((workType) => workType.type === 3).map((workType) => String(workType.id)),
            })),
            livelet_employee: construction?.employee_timesheet_item?.map((liveletEmployee) => ({
              employee_id: liveletEmployee.user_id,
              employee_name: liveletEmployee.user_id === 0 ? liveletEmployee.user_name : `${liveletEmployee.user.last_name} ${liveletEmployee.user.first_name}`,
              employee_memo: liveletEmployee.memo,
            })),
          })),
          // item_type: 1,
          start_time_check_alcohol: start_time_check_alcohol,
          end_time_check_alcohol: end_time_check_alcohol,
          start_capacity_alcohol: start_capacity_alcohol,
          end_capacity_alcohol: end_capacity_alcohol,
          alcohol_default_check: alcohol_default_check === 0 ? false : true,
          inspector_default_check: inspector_default_check === 0 ? false : true,
          driver_default_check: driver_default_check === 0 ? false : true,
          vehicle_default_check: vehicle_default_check === 0 ? false : true,
          device_default_check: device_default_check === 0 ? false : true,
        };
        setDateUpdate(date);
        setIdTimeSheetItem(id);
        reset(nightShiftValuesForm);
      } catch (error) {
        console.log(error);
      } finally {
        setEditLoading(false);
      }
    };
    nightShiftDetails();
  }, [employees, reset, params?.id, parsed?.id]);

  const handleCloseModal = () => {
    setIsSuccess(false);
    navigatePreservingQuery(appRouteEnums.PATH_TIMESHEET);
  };

  return (
    <StyledNewTimeSheetForm>
      {/* <AppTopBar /> */}
      <CircularLoader loading={loading || editLoading || isSubmitting || isSubmittingFormUpdate} />
      <AppModal open={isSuccess} handleClose={handleCloseModal}>
        <AppAlert icon={<img src={hot_yellow_frame} alt="icon" />} text={successMessage} handleClose={handleCloseModal} />
      </AppModal>
      <div className="detail">
        <div className="detail__top">
          {/* <p className="detail__top-icon" onClick={() => history.goBack()}>
            <AppIconButton icon={<img src={mobile_arrow_left} alt="icon" />} />
          </p> */}
          <p className="detail__top-title">日報</p>
          <div className="detail__top-status">
            {(status === OT_STATUS_PENDING) && (
              <div className="detail__top-pending">
                <span className="text">未決</span>
              </div>
            )}
            {status === OT_STATUS_OK && (
              <div className="detail__top-checked">
                <span className="text">OK</span>
                <img className="approvalIcon" src={checkIcon} alt="icon" />
              </div>
            )}
            {status === OT_STATUS_REJECT && (
              <div className="detail__top-unChecked">
                <span className="text">NG</span>
                <img className="approvalIcon" src={xIcon} alt="icon" />
              </div>
            )}
          </div>
        </div>
        {/* <Box sx={{ display: "flex", justifyContent: "center" }}> */}
        <div className="detail__content">
          <div className="detail__contentTop">
            <TimeSheetUserInfo
              last_name={userInfo?.last_name}
              first_name={userInfo?.first_name}
              type={idSelectType}
            // date={new Date()}
            // handleChange={handleChangeDate}
            // created_at={data?.created_at}
            />
            <p className="detail__name">{userInfo?.last_name} {userInfo?.first_name}</p>
          </div>
          <div className="boxWrapper">
            {/* <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              > */}
            <div className="detail__group">
              <p className="label">グループ</p>

              <p className="main">{nameGroup && nameGroup}</p>
            </div>
            {/* </Box> */}
          </div>
          <CustomFormProvider form={form} onSubmit={onSubmit}>
            <FormSheetNightShift />
          </CustomFormProvider>
        </div>
        <OTApprovalProcess showForm={false} data={tsData} />
        {/* </Box> */}
      </div>
    </StyledNewTimeSheetForm>
  );
}
